import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Modal } from 'components/shared/Modal/Modal'
import { SheetPreview } from 'components/shared/SheetPreview/SheetPreview'

import { DownloadIcon } from 'components/shared/Icon/model'

import styles from './ExportResourceModal.module.scss'

export const ExportResourceModal = ({
  data,
  message,
  title,
  onCancel,
  onClose,
  onExportCSV,
  onExportXLSX,
  isOpen,
}) => (
  <Modal
    className={styles.modal}
    cancelLabel={t`Cancel`}
    {...{ title, onCancel, onClose, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <Box
        align="center"
        className={styles.description}
        justify="space-between"
      >
        <p className={styles.text}>{message}</p>
        <Box>
          <Button
            className={styles.button}
            icon={DownloadIcon}
            label={t`Download CSV`}
            size="small"
            variant="text"
            onClick={onExportCSV}
          />
          <Button
            className={styles.button}
            icon={DownloadIcon}
            label={t`Download Excel`}
            size="small"
            variant="text"
            onClick={onExportXLSX}
          />
        </Box>
      </Box>
      <SheetPreview {...{ data }} />
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
